// OWA's message: { event: 'TICKET_CREATED', conversationId, ticketId, number, title }.
// It comes from another origin, so anything off-contract is ignored.

const OBJECT_ID = /^[0-9a-fA-F]{24}$/

// Keyed by ticket: the real note's id is not known until it arrives.
export const ticketPlaceholderId = (ticketId) => `temp-ticket-${ticketId}`

export function parseTicketCreatedMessage(data) {
  if (!data || data.event !== 'TICKET_CREATED') return null
  const { conversationId, ticketId, number, title } = data
  if (typeof conversationId !== 'string' || !OBJECT_ID.test(conversationId)) return null
  if (typeof ticketId !== 'string' || !OBJECT_ID.test(ticketId)) return null
  if (!Number.isInteger(number) || number < 1) return null
  if (typeof title !== 'string') return null
  return { conversationId, ticketId, number, title }
}

// NoteEvent renders note text through v-html, and the title is user-authored.
function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

// The same text the ticket-note-writer job writes.
export const ticketNoteText = ({ number, title }) =>
  `Created ticket #${number}: ${escapeHtml(title)}`
